import { ElementType, FC, ReactNode } from "react"
import React from "react"

import { Link, SxProps, Theme } from "../../mui.components"

export interface ILinkTextProps {
  to?: string
  href?: string
  icon?: ReactNode | null
  linkText: string
  sxProp?: SxProps<Theme>
  component: ElementType
  color?: string
  underline?: "none" | "always" | "hover" | undefined
}

const LinkText: FC<ILinkTextProps> = ({
  to,
  href,
  icon = null,
  linkText,
  component,
  color,
  sxProp = undefined,
  underline = undefined,
}) => {
  return (
    <Link
      component={component}
      to={to}
      href={href}
      variant={"body2"}
      color={color ?? "text.secondary"}
      underline={underline}
      sx={{ display: "flex", ...sxProp }}
    >
      {linkText} {icon || ""}
    </Link>
  )
}

export default LinkText
